const {
  optionFromString
} = require('../lib/option');
const mmDeliveryFormPickBehavior = async (source, content, parentContentPath, transientContext, nativeFunctions, sourceEvaluator) => {
  const {
    selection = {},
    content: {
      deliveryForm = {}
    } = {}
  } = transientContext;
  const [deliveryFormID] = Object.keys(deliveryForm);
  if (deliveryFormID === undefined) {
    return;
  }
  const collection = {};
  let numAssets = 0;
  const assetPatches = [{
    stage: null
  }, {
    stage: optionFromString('Pending Shipment')
  }];
  const formTypes = Object.keys(selection);
  for (let i = 0; i < formTypes.length; i += 1) {
    const formType = formTypes[i];
    const formIDs = selection[formType];
    for (let j = 0; j < formIDs.length; j += 1) {
      const formID = formIDs[j];
      collection[formID] = {
        form: {
          [formID]: {
            _formRef: formID
          }
        },
        _created: numAssets + 1
      };
      numAssets += 1;

      // eslint-disable-next-line no-await-in-loop
      await sourceEvaluator({
        type: 'patchContentBehavior',
        unsafePatch: true,
        id: formID,
        patches: assetPatches
      });
    }
  }
  await sourceEvaluator({
    type: 'patchContentBehavior',
    id: deliveryFormID,
    patches: [{
      assetsPicked: collection
    }]
  });
  const addedString = numAssets === 1 ? '1 asset' : `${numAssets} assets`;
  await sourceEvaluator({
    type: 'alertBehavior',
    message: `${addedString} added.`,
    options: [{
      title: 'OK'
    }]
  });
};
module.exports = {
  evaluate: mmDeliveryFormPickBehavior
};